import $ from "jquery";
import "./../styles/main.scss";
require('./woocommerce/Global');
require('./helpers/CookieConsent');
$(document).ready(function () {
    $("body").on("click", "a[data-goto]", function (e) {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href");
        if (node.length) {
            var posY = $(node).offset().top - $("#main-header").height();
            if (posY >= 0) {
                $.scrollTo(posY, 400);
            }
        }
    });
    $('body').on("click", ".shared-item", function (e) {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    $("body").on("click", "#menu-switcher a", function (e) {
        e.preventDefault();
        $("#nav-main").toggleClass("show-menu");
        $(e.currentTarget).toggleClass("show-menu");
    });
    $("body").on("click", ".goTo", function (e) {
        var elm = $(e.currentTarget).attr("href");
        var posY = $(elm).offset().top - $("#main-header").height();
        $.scrollTo(posY, 400);
    });
    if ($(".page-template-tpl-contest").length) {
        $('.Button.download').on("click", function (e) {
            document.location = $(e.currentTarget).attr("data-next");
            setInterval(function () {
                document.location = $(e.currentTarget).attr("data-next");
            }, 1000);
        });
        $('.date-picker').on("focus", function (e) {
            $(e.currentTarget).attr("type", "date");
        });
        // $('.date-picker').on("blur", (e) => {
        //     $(e.currentTarget).attr("type","text");
        // });
    }
    $('.language-switcher').on("click", "a", function (e) {
        e.preventDefault();
        $("#screen-language-switcher").fadeIn(300);
    });
    $("#screen-language-switcher").on("click", "a[href='#close']", function (e) {
        e.preventDefault();
        $("#screen-language-switcher").fadeOut(300);
    });
});
